import type { NewsletterLayout, NewsletterProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { ColorField, NumberField, SelectField, TextField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

const LAYOUT = ["inline", "stacked", "centered-card"] as const;
const METHOD = ["POST", "GET"] as const;

export function NewsletterInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as NewsletterProps;

  return (
    <>
      <SelectField
        label="Layout"
        value={p.layout ?? "centered-card"}
        options={LAYOUT}
        onChange={(v) => update(widget.id, { layout: v as NewsletterLayout })}
      />
      <TextField
        label="Title"
        value={p.title ?? ""}
        onChange={(v) => update(widget.id, { title: v || undefined })}
      />
      <TextField
        label="Subtitle"
        value={p.subtitle ?? ""}
        multiline
        onChange={(v) => update(widget.id, { subtitle: v || undefined })}
      />
      <TextField
        label="Placeholder"
        value={p.placeholder}
        onChange={(v) => update(widget.id, { placeholder: v })}
      />
      <TextField
        label="Button text"
        value={p.buttonText}
        onChange={(v) => update(widget.id, { buttonText: v })}
      />
      <TextField
        label="Form action"
        value={p.action}
        onChange={(v) => update(widget.id, { action: v })}
      />
      <SelectField
        label="Method"
        value={p.method ?? "POST"}
        options={METHOD}
        onChange={(v) => update(widget.id, { method: v as NewsletterProps["method"] })}
      />
      <TextField
        label="Field name"
        value={p.fieldName ?? "email"}
        onChange={(v) => update(widget.id, { fieldName: v || "email" })}
      />
      <TextField
        label="Note / disclaimer"
        value={p.note ?? ""}
        onChange={(v) => update(widget.id, { note: v || undefined })}
      />
      <ColorField
        label="Background"
        value={p.background ?? "#f8fafc"}
        onChange={(v) => update(widget.id, { background: v })}
      />
      <ColorField
        label="Text"
        value={p.textColor ?? "#0f172a"}
        onChange={(v) => update(widget.id, { textColor: v })}
      />
      <ColorField
        label="Accent (button)"
        value={p.accent ?? "#111827"}
        onChange={(v) => update(widget.id, { accent: v })}
      />
      <NumberField
        label="Radius (px)"
        value={p.radius ?? 12}
        min={0}
        max={32}
        onChange={(v) => update(widget.id, { radius: v })}
      />
    </>
  );
}
